<template>
  <div>
    <div class="flex">
      <input
        v-bind="$attrs"
        resize="both"
        v-model="keyword"
        class="outline-none border-1px border-main pl-4"
        @keyup.enter="$emit('search', keyword)"
      />
      <el-button
        size="mini"
        type="primary"
        class="rounded-l-none"
        @click="$emit('search', keyword)"
      >
        <span class="iconfont icon-sousuo"></span>
      </el-button>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import { defineComponent } from "@vue/runtime-dom";

export default defineComponent({
  setup() {
    const keyword = ref("");
    return { keyword };
  },
});
</script>

<style scoped lang="scss">

</style>
